import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LotieAnimationItem = styled.div`
  width: 100%;
  max-width: 300px;

  @media (max-width: 768px) {
    max-width: 200px;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.vars.palette.text.primary};
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  text-align: center;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.vars.palette.text.secondary};
  font-size: 14px;
  line-height: 21px;
  max-width: 250px;
  text-align: center;
  margin-top: 5px;
`;
export const Spacer = styled.div`
  margin-top: 16px;
`;
